var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgItsoftHeart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interface-favorite-give-heart--reward-social-rating-media-heart-hand",
    clipPath: "url(#clip0_271_1118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.35693 14.5715H4.78551C5.92215 14.5715 7.01224 15.023 7.81596 15.8267C8.61969 16.6305 9.07122 17.7205 9.07122 18.8572",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.92836 18.8572H12.4998C13.4091 18.8572 14.2812 19.2184 14.9242 19.8614C15.5671 20.5044 15.9284 21.3764 15.9284 22.2857C15.9284 22.5131 15.8381 22.7311 15.6773 22.8918C15.5166 23.0526 15.2985 23.1429 15.0712 23.1429H1.35693",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.4999 14.5714L8.64271 8.22859C4.90557 4.4743 10.357 -2.79427 15.4999 3.08573C20.6427 -2.77713 26.1456 4.49144 22.357 8.22859L15.4999 14.5714Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_271_1118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgItsoftHeart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/itsoft_heart.c8986bdb6c8a7c0440844d8fe6c4ea19.svg";